import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';

import { Checkbox, Grid, IconButton } from '@material-ui/core';
import { AddBox, ClearRounded} from '@material-ui/icons';
import ButtonComponent from '@components/Shared/Buttons/Button';
import Modal from '@src/components/Shared/Modal/ModalPure';
import AddCorrespondencia from '@src/Pages/Private/Cliente/Admin/CorrespondenciaDevolvida/AddCorrespondencia';

import CountDown from '@components/Shared/CountDown';
import TableCustomKeysNoPagination from '@src/Pages/Private/Cliente/Admin/CorrespondenciaDevolvida/TableCustomKeysNoPagination';
import { TitlePage } from '@src/@styles/styles.global';

import Services, {
  ICorrespDevolvidaTable,
  ISolicitacaoResultTable
} from './services';

import TableRow from '@material-ui/core/TableRow';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Collapse from '@material-ui/core/Collapse';

import { Form, Select as SelectAntd } from 'antd';

import {
  StyledTableCell,
  StyledTableRow,
} from '@src/components/Shared/Tables/TableCollapsible/styles';

const columnsLabel = {

  id_pessoa: 'ID pessoa',
  nome: 'Nome',
  mala_mensal: 'Mala mensal?',
  data_envio: 'Data envio',
  data_devolucao: 'Data devolução',
  motivo_devolucao: 'Motivo devolução',
};


interface IProps {
  idPerfil: number;
  functionReload?: Function;
  idSolicitacao: number;
}

const ListCorrespondenciaDevolvida: React.FC<IProps> = ({
  idPerfil,
  functionReload,
  idSolicitacao,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<ICorrespDevolvidaTable[]>([]);


  const [openModalAddCorrespondencia, setOpenModalAddCorrespondencia] =
    useState(false);
    const [openModalDeleteCorrespondencia, setOpenModalDeleteCorrespondencia] =
    useState(false);
    const [openModalAproveCorrespondencia, setOpenModalAproveCorrespondencia] =
    useState(false);

  const [tipoAcaoId, setTipoAcaoId] = useState<number>(0);
  const [tipoAcaoDescricao, setTipoAcaoDescricao] = useState('');

  const [dadosSelecionadas, setDadosSelecionadas] = useState<string[]>([]);

  async function loadCorrespDevolvida ()  {
    setLoading(true);
    const services = new Services();

    const { error, response } = await services.DetalhesCorrespDevolvida();

    if (!error && response) {
      setData(response);
    }

    setLoading(false);
  };

  const finishAddCorrespondencia = async () => {
    if (functionReload) {
      await functionReload();
    }
    setOpenModalAddCorrespondencia(false);
  };

  const finishDeleteCorrespondencia = async () => {
    if (functionReload) {
      await functionReload();
    }
    setOpenModalDeleteCorrespondencia(false);
  };

  const finishAproveCorrespondencia = async () => {
    if (functionReload) {
      await functionReload();
    }
    setOpenModalAproveCorrespondencia(false);
  };

  const selectedDatas = (value: ISolicitacaoResultTable) => {
    if (dadosSelecionadas.filter(x => x === value.id_correspondencia_devolvida).length <= 0) {
      setDadosSelecionadas([...dadosSelecionadas, value.id_correspondencia_devolvida]);
    } else {
      const newArray = dadosSelecionadas.filter(function (item) {
        return item !== value.id_correspondencia_devolvida;
      });

      setDadosSelecionadas(newArray);
    }
  };

  console.log('Testando', dadosSelecionadas)


  useEffect(() => {
   loadCorrespDevolvida();
    window.document.title = 'CRM - Lista de Correspondência devolvida';
  }, []);

  return (
    <Grid container>
      <Grid item md={12} xs={12}>
        <TitlePage style={{ margin: 5 }}>Correspondência Devolvida</TitlePage>
      </Grid>

      <Grid
        container
        alignItems="center"
        item
        md={12}
        xs={12}
        style={{ margin: 5 }}
      >

        <Modal
          title="Nova correspondência"
          size="gigante"
          openModal={openModalAddCorrespondencia}
          controlModal={(value: boolean) =>
            setOpenModalAddCorrespondencia(value)
          }
        >
          <AddCorrespondencia
            //perfil_id={idPerfil}
            finishCreate={finishAddCorrespondencia}
            //ids_solicitacao={dadosSelecionadas}
          />
        </Modal>

        <Grid item md={2} xs={4} style={{ margin: 5 }}>

        <ButtonComponent
            color="secondary"
            onClick={() => setOpenModalAddCorrespondencia(true)}
            fullWidth
            style={{ height: 46 }}
          >
            <AddBox style={{paddingRight: 5}}/>
            Adicionar

          </ButtonComponent>


        </Grid>

      </Grid>


        <Grid container item lg={12} xs={12}>
          <Grid item lg={8} xs={8}>
            {/*<CountDown
              minutesDefault={1}

              title="Tempo para atualização dos dados"
        />*/}
          </Grid>

      </Grid>
     <Grid item lg={11} xs={12}>
        <TableCustomKeysNoPagination
          loading={loading}
          columns={[columnsLabel]}
          FieldsBold={['nome']}
          data={data}
          keys={[
            'id_pessoa',
            'nome',
            'mala_mensal',
            'data_envio',
            'data_devolucao',
            'motivo_devolucao',
          ]}
          Actions={[ ]}

        />
      </Grid>

    </Grid>
  );
};

export default ListCorrespondenciaDevolvida;
